const carBrandReducer = (state, action) => {
    switch (action.type) {
        case "SET_CAR_BRAND":
            return {
                ...state,
                brand: action.payload
            };
        case "CLEAR_CAR_BRAND":
            return {
                ...state,
                brand: null
            };
        default:
            return state;
    }
};

export default carBrandReducer;
